/**
 * Locations block — Google Maps JS API.
 *
 * Loaded only on pages carrying acf/locations, and only when TLR_GMAPS_KEY
 * is defined. The Maps API calls tlrInitMap() itself via its ?callback
 * parameter once it has finished loading, which is why this is a global
 * function rather than an IIFE like the theme's other scripts.
 *
 * Adapted from the Woodland build, with two changes: the palette follows
 * the TLR tokens, and it binds to every .loc-map on the page rather than a
 * single hardcoded id.
 *
 * It IS part of inc/js/main.js like every other partial here, so the Maps
 * API script must declare `main` as a dependency — otherwise the callback
 * can fire before tlrInitMap exists. uglify leaves top-level function names
 * alone, so the global survives minification.
 */

/* global google */
function tlrInitMap() {
  var maps = document.querySelectorAll(".loc-map");
  if (!maps.length || typeof google === "undefined") return;

  // Warm paper tones so the map reads as an inset panel on the dark section
  // rather than a bright rectangle punched into it.
  var STYLES = [{
    elementType: "geometry",
    stylers: [{
      color: "#efe9dd"
    }]
  }, {
    elementType: "labels.text.fill",
    stylers: [{
      color: "#5a4f42"
    }]
  }, {
    elementType: "labels.text.stroke",
    stylers: [{
      color: "#f4efe6"
    }]
  }, {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{
      color: "#d8cdb8"
    }]
  }, {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{
      color: "#1c1815"
    }]
  }, {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{
      color: "#e4e2d2"
    }]
  }, {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{
      color: "#6b7a5a"
    }]
  }, {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{
      color: "#d3ddc4"
    }]
  }, {
    featureType: "road",
    elementType: "geometry",
    stylers: [{
      color: "#ffffff"
    }]
  }, {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{
      color: "#e8dfce"
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{
      color: "#e8dfce"
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{
      color: "#c9b48f"
    }]
  }, {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{
      color: "#e4e2d2"
    }]
  }, {
    featureType: "water",
    elementType: "geometry",
    stylers: [{
      color: "#b8c4ab"
    }]
  }, {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{
      color: "#6b7a5a"
    }]
  }];
  var PIN = {
    path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" + "m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
    fillColor: "#B1502E",
    fillOpacity: 1,
    strokeColor: "#F4EFE6",
    strokeWeight: 1.5,
    scale: 1.7,
    anchor: new google.maps.Point(12, 22)
  };
  function build(mapEl) {
    var section = mapEl.closest(".locations");
    if (!section) return;
    var buttons = [].slice.call(section.querySelectorAll(".loc-chip-btn"));
    if (!buttons.length) return;
    var badge = document.getElementById(mapEl.getAttribute("data-badge"));
    var locs = buttons.map(function (btn) {
      return {
        lat: parseFloat(btn.dataset.lat) || 0,
        lng: parseFloat(btn.dataset.lng) || 0,
        zoom: parseInt(btn.dataset.zoom, 10) || 14,
        label: btn.dataset.label || ""
      };
    });
    var map = new google.maps.Map(mapEl, {
      center: {
        lat: locs[0].lat,
        lng: locs[0].lng
      },
      zoom: locs[0].zoom,
      styles: STYLES,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      }
    });
    var markers = locs.map(function (loc, i) {
      var marker = new google.maps.Marker({
        position: {
          lat: loc.lat,
          lng: loc.lng
        },
        map: map,
        title: loc.label,
        icon: PIN
      });
      marker.addListener("click", function () {
        activate(i);
      });
      return marker;
    });
    function activate(i) {
      buttons.forEach(function (btn, n) {
        var on = n === i;
        btn.setAttribute("aria-pressed", on ? "true" : "false");
        var card = btn.closest(".loc-chip");
        if (card) card.classList.toggle("is-on", on);
      });
      if (badge) badge.textContent = locs[i].label;
      map.panTo({
        lat: locs[i].lat,
        lng: locs[i].lng
      });
      map.setZoom(locs[i].zoom);
      markers[i].setAnimation(google.maps.Animation.BOUNCE);
      window.setTimeout(function () {
        markers[i].setAnimation(null);
      }, 700);
    }
    buttons.forEach(function (btn, i) {
      btn.addEventListener("click", function () {
        activate(i);
      });
    });

    // Opens on the first location rather than fitting all the pins in view:
    // the first card is the one shown as selected, so the map should agree
    // with it. (A fitBounds pass used to run here and, being deferred, it
    // overrode this initial framing.)
    activate(0);
  }
  for (var i = 0; i < maps.length; i++) {
    build(maps[i]);
  }
}